<template>
  <div>
    <div>
      <hr class="hr">
      <template>
        <el-alert
            center
            :title="'提示：您的文档可保留10日，请及时下载。'"
            type="">
        </el-alert>
      </template>
    </div>
    <center>
      <div style="height: 894px;
    width: 1200px;padding-top: 13px;">
        <el-form ref="filelistform" style="float: right;
    z-index: 2000;
    position: relative;height: 50px;
    padding-top: 6px;" :inline="true" label-width="80px"
                 class="demo-form-inline">
          <el-form-item style="line-height: 10%;">
            <el-select v-model="statusList" collapse-tags placeholder="状态" size="small"
                       @change="handleStatusChange">
              <el-option
                  v-for="item in fileStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="line-height: 10%;">
            <el-input suffix-icon="el-icon-search" v-model="fileName" placeholder="文件名" size="small"
                      @change="handleNameChange"></el-input>
          </el-form-item>
        </el-form>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="翻译文档" name="first">
            <div class="filelist-domain">
              <div>
                <el-table
                    :v-loading="transloading"
                    size="small"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{ 'background': '#D3DEE8','line-height': '30px','height': '64px'}"
                    @selection-change="handleSelectionChange">
                  <el-table-column
                      label-class-name="xuhao"
                      label="序号"
                      type="index"
                      width="80"
                      align="center"
                      prop="id"
                      :index="indexMethod">
                  </el-table-column>
                  <el-table-column
                      label-class-name="wendang"
                      label="文档名"
                      show-overflow-tooltip
                      prop="name">
                  </el-table-column>
                  <el-table-column
                      show-overflow-tooltip
                      label-class-name="fanyi"
                      prop="language"
                      label="翻译语言"
                      width="150"
                      align="center">
                  </el-table-column>
                  <el-table-column
                      label-class-name="zhuangtai"
                      prop="status"
                      label="状态"
                      width="150"
                      align="center">
                    <template slot-scope="scope">
            <span
                :style="scope.row.status==='翻译失败'?'color:red;font-size:12px;':scope.row.status==='待支付'?'color:#e13f3f':scope.row.status==='排队中'?'color:#e55050':scope.row.status==='已翻译'?'color:#4aaaea':scope.row.status==='已下载'||scope.row.status==='已删除'||scope.row.status==='已过期'?'color:#9a9a9a':''">{{
                scope.row.status
              }}</span>
                      <span v-show="scope.row.status==='翻译失败'&&scope.row.refundMode==='1'" style="color:red;font-size:12px "> 支付金额已退款到个人钱包</span>
                      <span v-show="scope.row.status==='翻译失败'&&scope.row.refundMode==='2'" style="color:red;font-size:12px "> 支付金额已退款到机构余额</span>
                      <el-progress class="listprogress" :text-inside="false"
                                   v-show="scope.row.status==='翻译中'" :stroke-width="7"
                                   :percentage="scope.row.numbers"
                                   :color="customColor"></el-progress>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label-class-name="yeshu"
                      prop="pageNum"
                      label="校验页数"
                      width="100"
                      align="center">
                  </el-table-column>
                  <el-table-column
                      label-class-name="yeshu"
                      align="center"
                      label="上传时间"
                      prop="datetime"
                      width="170">
                  </el-table-column>
                  <el-table-column
                      label-class-name="caozuo"
                      label="操作"
                      align="center"
                      width="180"
                      prop="disables">
                    <template slot-scope="scope">
                      <el-row v-if="scope.row.status!=='待支付'">
                        <el-button type="text" data-track-text="阅读文档" aria-label="阅读文档" style="color: #606266"
                                   @click="readingFile(scope.row)"
                                   :disabled="scope.row.disables.disablesread">阅读
                        </el-button>
                        <el-button type="text" data-track-text="下载文档" aria-label="下载文档" style="color: #606266;margin-right: 10px"
                                   @click="downloadFile(scope.row)"
                                   :disabled="scope.row.disables.disablesdown">下载
                        </el-button>
                        <el-popover placement="top" width="300"
                                    :ref="`popover-${scope.$index}`">
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button
                                data-track-text="取消删除文档"
                                aria-label="取消删除文档"
                                size="mini"
                                @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">
                              取消
                            </el-button>
                            <el-button type="primary"
                                       data-track-text="确认删除文档"
                                       aria-label="确认删除文档"
                                       style="background-color:#184482;border-color:#184482;"
                                       size="mini"
                                       @click="deleteFile(scope)">确定
                            </el-button>
                          </div>
                          <el-button :disabled="scope.row.disables.disablesdel" type="text"
                                     data-track-text="删除文档"
                                     aria-label="删除文档"
                                     style="color: #606266"
                                     slot="reference">删除
                          </el-button>
                        </el-popover>
                      </el-row>
                      <el-row v-if="scope.row.status==='待支付'">
                        <el-button type="text" data-track-text="继续支付" aria-label="继续支付" style="color: #606266;margin-right: 10px"
                                   @click="pay(scope.row)"
                        >支付
                        </el-button>
                        <el-popover placement="top" width="300"
                                    :ref="`popover-${scope.$index}`">
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button
                                data-track-text="取消删除文档"
                                aria-label="取消删除文档"
                                size="mini"
                                @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">
                              取消
                            </el-button>
                            <el-button type="primary"
                                       data-track-text="确认删除文档"
                                       aria-label="确认删除文档"
                                       style="background-color:#184482;border-color:#184482;"
                                       size="mini"
                                       @click="deleteFile(scope)">确定
                            </el-button>
                          </div>
                          <el-button type="text" data-track-text="删除文档" aria-label="删除文档" style="color: #606266"
                                     slot="reference">删除
                          </el-button>
                        </el-popover>
                      </el-row>
                    </template>
                  </el-table-column>
                </el-table>
                <div v-if="count!==0"
                     style="margin-top: 10px;float: left;font-size: 14px;margin-bottom: 40px">
                  共{{ count }}条
                </div>
                <div v-if="count!==0" style="margin-top: 20px;float: right">
                  <el-pagination
                      background
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size=10
                      :pager-count=11
                      layout="prev, pager, next"
                      :total="count">
                  </el-pagination>
                </div>
              </div>
              <el-dialog
                  :title="downloadTitle"
                  :visible.sync="centerDialogVisible"
                  width="555px"
                  center>
                <div :class="downloadClass">
                  <div v-show="isDownload" style="    text-align: left;
    font-size: 18px;
              font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #666666;
    margin-left: 94px;">译文下载
                  </div>
                  <div v-show="isDownload" style="margin: 0px 69.5px;">
                    <div class="down-type">
                      <img src="../assets/doc.png" alt="" data-track-text="选择DOC格式" aria-label="选择DOC格式" style="width: 54px;height: 68px"
                           @click="radio='doc'">
                      <el-radio v-model="radio" label="doc"></el-radio>
                      <div style="line-height: 0;
    margin-top: 9px;">doc
                      </div>
                    </div>
                    <div class="down-type">
                      <img src="../assets/docx.png" alt="" data-track-text="选择DOCX格式" aria-label="选择DOCX格式" style="width: 54px;height: 68px"
                           @click="radio='docx'">
                      <el-radio v-model="radio" label="docx"></el-radio>
                      <div style="line-height: 0;
    margin-top: 9px;">docx
                      </div>
                    </div>
                    <div class="down-type">
                      <img src="../assets/pdf.png" alt="" data-track-text="选择PDF格式" aria-label="选择PDF格式" style="width: 54px;height: 68px"
                           @click="radio='pdf'">
                      <el-radio v-model="radio" label="pdf"></el-radio>
                      <div style="line-height: 0;
    margin-top: 9px;">pdf
                      </div>
                    </div>
                    <div class="down-type">
                      <img src="../assets/txt.png" alt="" data-track-text="选择TXT格式" aria-label="选择TXT格式" style="width: 54px;height: 68px"
                           @click="radio='txt'">
                      <el-radio v-model="radio" label="txt"></el-radio>
                      <div style="line-height: 0;
    margin-top: 9px;">txt
                      </div>
                    </div>
                  </div>
                  <div v-show="isDownload" style="width: 115px;
          text-align: left;
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #666666;
          margin-left: 94px;
          margin-top: 110px;">双语对照下载
                  </div>
                  <div v-show="isDownload" style="margin: 0px 69.5px;">
                    <div class="down-type">
                      <img src="../assets/docx.png" alt="" data-track-text="选择原文批注DOCX" aria-label="选择原文批注DOCX" style="width: 54px;height: 68px"
                           @click="radio='commentsone'">
                      <el-radio v-model="radio" label="commentsone"></el-radio>
                      <div style="line-height: 0;
    margin-top: 9px;">原文做批注
                      </div>
                    </div>
                    <div class="down-type">
                      <img src="../assets/docx.png" alt="" data-track-text="选择译文批注DOCX" aria-label="选择译文批注DOCX" style="width: 54px;height: 68px"
                           @click="radio='commentstwo'">
                      <el-radio v-model="radio" label="commentstwo"></el-radio>
                      <div style="line-height: 0;
    margin-top: 9px;">译文做批注
                      </div>
                    </div>
                  </div>
                  <div v-show="isDownload"
                       style="position: absolute; left: 50%; top: 85%; transform: translate(-50%, 0px);">
                    <el-button class="el-button--primarys" type="primary" data-track-text="确认下载文档" aria-label="确认下载文档" style="margin-right: 11px"
                               :loading="downloadDocLoad"
                               @click="downloadDoc">下 载
                    </el-button>
                    <el-button class="el-button--defaults" data-track-text="取消下载文档" aria-label="取消下载文档" @click="centerDialogVisible = false">取
                      消
                    </el-button>
                  </div>
                  <div v-show="!isDownload">
                    <div style="line-height: 0;"><img src="../assets/downloadjindu.png" alt=""
                                                      style="height: 166px;width: 330px"></div>
                    <div style="width: 360px;
            height: 48px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgb(52, 52, 52);
            line-height: 30px;
            margin-left: 50%;
            transform: translate(-50%, 0px);
            margin-bottom: 42px;
            "><span>{{ downloadMessage }}</span></div>
                    <div style="position: absolute;left: 50%;transform: translate(-50%,0)">
                      <el-progress :color="customColorDownload" style="width: 395px;" id="test"
                                   :text-inside="true"
                                   :stroke-width="28"
                                   :percentage="downloadPercentage"></el-progress>
                    </div>
                  </div>
                </div>
              </el-dialog>
              <el-dialog
                  :title="downloadTitle"
                  :visible.sync="excelDialogVisible"
                  width="555px"
                  center>
                <div :class="downloadClass">
                  <div v-show="isDownload" style="margin: 20px 69.5px;">
                    <div class="down-type2">
                      <img src="../assets/txt.png" alt="" data-track-text="选择XLS格式" aria-label="选择XLS格式" style="width: 54px;height: 68px"
                           @click="radio!=='xls'?radio='xlsx':radio='xls'">
                      <el-radio v-model="radio" label="xls" :disabled="radio!=='xls'"></el-radio>
                      <div style="line-height: 0;
    margin-top: 9px;">xls
                      </div>
                    </div>
                    <div class="down-type2" :disabled="radio!=='xlsx'">
                      <img src="../assets/txt.png" alt="" data-track-text="选择XLSX格式" aria-label="选择XLSX格式" style="width: 54px;height: 68px"
                           @click="radio!=='xlsx'?radio='lsx':radio='xlsx'">
                      <el-radio v-model="radio" label="xlsx"
                                :disabled="radio!=='xlsx'"></el-radio>
                      <div style="line-height: 0;
    margin-top: 9px;">xlsx
                      </div>
                    </div>
                  </div>
                  <div v-show="isDownload"
                       style="position: absolute; left: 50%; top: 78%; transform: translate(-50%, 0px);">
                    <el-button class="el-button--primarys" type="primary" data-track-text="确认下载表格" aria-label="确认下载表格" style="margin-right: 11px"
                               :loading="downloadDocLoad"
                               @click="downloadDoc">下 载
                    </el-button>
                    <el-button class="el-button--defaults" data-track-text="取消下载表格" aria-label="取消下载表格" @click="excelDialogVisible = false">取 消
                    </el-button>
                  </div>
                  <div v-show="!isDownload">
                    <div style="line-height: 0;"><img src="../assets/downloadjindu.png" alt=""
                                                      style="height: 166px;width: 330px"></div>
                    <div style="width: 360px;
            height: 48px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgb(52, 52, 52);
            line-height: 30px;
            margin-left: 50%;
            transform: translate(-50%, 0px);
            margin-bottom: 42px;
            "><span>{{ downloadMessage }}</span></div>
                    <div style="position: absolute;left: 50%;transform: translate(-50%,0)">
                      <el-progress :color="customColorDownload" style="width: 395px;" id="test2"
                                   :text-inside="true"
                                   :stroke-width="28"
                                   :percentage="downloadPercentage"></el-progress>
                    </div>
                  </div>
                </div>
              </el-dialog>
            </div>
          </el-tab-pane>
          <el-tab-pane label="转换文档" name="second">
            <div class="filelist-domain">
              <div>
                <el-table
                    :v-loading="convertloading"
                    size="small"
                    ref="multipleTable"
                    :data="convertTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{ 'background': '#D3DEE8','line-height': '30px','height': '64px'}"
                    @selection-change="handleSelectionChange">
                  <el-table-column
                      label-class-name="xuhao"
                      label="序号"
                      type="index"
                      width="80"
                      align="center"
                      prop="id"
                      :index="indexConvertMethod">
                  </el-table-column>
                  <el-table-column
                      label-class-name="wendang"
                      label="文档名"
                      show-overflow-tooltip
                      prop="name">
                  </el-table-column>
                  <el-table-column
                      show-overflow-tooltip
                      label-class-name="fanyi"
                      prop="language"
                      label="格式转换"
                      width="150"
                      align="center">
                  </el-table-column>
                  <el-table-column
                      label-class-name="zhuangtai"
                      prop="status"
                      label="状态"
                      width="150"
                      align="center">
                    <template slot-scope="scope">
            <span
                :style="scope.row.status==='转换失败'?'color:red;font-size:12px;':scope.row.status==='待支付'?'color:#e13f3f':scope.row.status==='排队中'?'color:#e55050':scope.row.status==='已转换'?'color:#4aaaea':scope.row.status==='已下载'||scope.row.status==='已删除'||scope.row.status==='已过期'?'color:#9a9a9a':''">{{
                scope.row.status
              }}</span>
                      <span v-show="scope.row.status==='转换失败'&&scope.row.refundMode==='1'" style="color:red;font-size:12px "> 支付金额已退款到个人钱包</span>
                      <span v-show="scope.row.status==='转换失败'&&scope.row.refundMode==='2'" style="color:red;font-size:12px "> 支付金额已退款到机构余额</span>
                      <el-progress class="listprogress" :text-inside="false"
                                   v-show="scope.row.status==='转换中'" :stroke-width="7"
                                   :percentage="scope.row.numbers"
                                   :color="customColor"></el-progress>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label-class-name="yeshu"
                      prop="pageNum"
                      label="校验页数"
                      width="100"
                      align="center">
                  </el-table-column>
                  <el-table-column
                      label-class-name="yeshu"
                      align="center"
                      label="上传时间"
                      prop="datetime"
                      width="170">
                  </el-table-column>
                  <el-table-column
                      label-class-name="caozuo"
                      label="操作"
                      align="center"
                      width="180"
                      prop="disables">
                    <template slot-scope="scope">
                      <el-row v-if="scope.row.status!=='待支付'">
                        <el-button type="text" data-track-text="下载转换文档" aria-label="下载转换文档" style="color: #606266;margin-right: 10px"
                                   @click="downloadConvertFile(scope.row)"
                                   :disabled="scope.row.disables.disablesdown">下载
                        </el-button>
                        <el-popover placement="top" width="300"
                                    :ref="`popover-${scope.$index}`">
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button
                                data-track-text="取消删除文档"
                                aria-label="取消删除文档"
                                size="mini"
                                @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">
                              取消
                            </el-button>
                            <el-button type="primary"
                                       data-track-text="确认删除文档"
                                       aria-label="确认删除文档"
                                       style="background-color:#184482;border-color:#184482;"
                                       size="mini"
                                       @click="deleteFile(scope)">确定
                            </el-button>
                          </div>
                          <el-button :disabled="scope.row.disables.disablesdel" type="text"
                                     data-track-text="删除文档"
                                     aria-label="删除文档"
                                     style="color: #606266"
                                     slot="reference">删除
                          </el-button>
                        </el-popover>
                      </el-row>
                      <el-row v-if="scope.row.status==='待支付'">
                        <el-button type="text" data-track-text="继续支付" aria-label="继续支付" style="color: #606266;margin-right: 10px"
                                   @click="pay(scope.row)"
                        >支付
                        </el-button>
                        <el-popover placement="top" width="300"
                                    :ref="`popover-${scope.$index}`">
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button
                                data-track-text="取消删除文档"
                                aria-label="取消删除文档"
                                size="mini"
                                @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">
                              取消
                            </el-button>
                            <el-button type="primary"
                                       data-track-text="确认删除文档"
                                       aria-label="确认删除文档"
                                       style="background-color:#184482;border-color:#184482;"
                                       size="mini"
                                       @click="deleteFile(scope)">确定
                            </el-button>
                          </div>
                          <el-button type="text" data-track-text="删除文档" aria-label="删除文档" style="color: #606266"
                                     slot="reference">删除
                          </el-button>
                        </el-popover>
                      </el-row>
                    </template>
                  </el-table-column>
                </el-table>
                <div v-if="countConvert!==0"
                     style="margin-top: 10px;float: left;font-size: 14px;margin-bottom: 40px">
                  共{{ countConvert }}条
                </div>
                <div v-if="countConvert!==0" style="margin-top: 20px;float: right">
                  <el-pagination
                      background
                      @size-change="handleConvertSizeChange"
                      @current-change="handleConvertCurrentChange"
                      :current-page="currentConvertPage"
                      :page-size=10
                      :pager-count=11
                      layout="prev, pager, next"
                      :total="countConvert">
                  </el-pagination>
                </div>
              </div>
              <el-dialog
                  :title="downloadTitle"
                  :visible.sync="excelDialogVisibleConvert"
                  width="555px"
                  center>
                <div :class="downloadClass">
                  <div v-show="isDownload" style="margin: 20px 69.5px;">
                    <div class="down-type2">
                      <img src="../assets/doc.png" alt="" data-track-text="选择DOC格式" aria-label="选择DOC格式" style="width: 54px;height: 68px"
                           @click="radio='doc'">
                      <el-radio v-model="radio" label="doc"></el-radio>
                      <div style="line-height: 0; margin-top: 9px;">doc
                      </div>
                    </div>
                    <div class="down-type2" :disabled="radio!=='docx'">
                      <img src="../assets/docx.png" alt="" data-track-text="选择DOCX格式" aria-label="选择DOCX格式" style="width: 54px;height: 68px"
                           @click="radio='docx'">
                      <el-radio v-model="radio" label="docx"></el-radio>
                      <div style="line-height: 0;
    margin-top: 9px;">docx
                      </div>
                    </div>
                  </div>
                  <div v-show="isDownload"
                       style="position: absolute; left: 50%; top: 78%; transform: translate(-50%, 0px);">
                    <el-button class="el-button--primarys" type="primary" data-track-text="确认下载转换文档" aria-label="确认下载转换文档" style="margin-right: 11px"
                               :loading="downloadDocLoad"
                               @click="downloadConvertDoc">下 载
                    </el-button>
                    <el-button class="el-button--defaults"
                               data-track-text="取消下载转换文档"
                               aria-label="取消下载转换文档"
                               @click="excelDialogVisibleConvert = false">取 消
                    </el-button>
                  </div>
                  <div v-show="!isDownload">
                    <div style="line-height: 0;"><img src="../assets/downloadjindu.png" alt=""
                                                      style="height: 166px;width: 330px"></div>
                    <div style="width: 360px;
            height: 48px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgb(52, 52, 52);
            line-height: 30px;
            margin-left: 50%;
            transform: translate(-50%, 0px);
            margin-bottom: 42px;
            "><span>{{ downloadMessage }}</span></div>
                    <div style="position: absolute;left: 50%;transform: translate(-50%,0)">
                      <el-progress :color="customColorDownload" style="width: 395px;" id="test3"
                                   :text-inside="true"
                                   :stroke-width="28"
                                   :percentage="downloadPercentage"></el-progress>
                    </div>
                  </div>
                </div>
              </el-dialog>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </center>
    <el-dialog :visible.sync="dialogTableVisible" :close-on-click-modal="false" class="payClass">
      <div slot="title" class="dialog-title">
        <span v-if="checkType==='first'" class="fanyiyuyan">翻译语言：</span>
        <span v-if="checkType!=='first'" class="fanyiyuyan">转换类型：</span>
        <div style="display: inline;float: left;">
          <el-form>
            {{ to }}
          </el-form>
        </div>
      </div>
      <el-table :data="gridData"
                :header-cell-style="{ 'background': '#d3dee8','line-height': '30px','height': '23px',
                'text-align':'center','font-size':'14px','color':'#333333'}"
      >
        <el-table-column type="index" property="id" label="序号" width="50" align="center"></el-table-column>
        <el-table-column property="title" label="题名" show-overflow-tooltip></el-table-column>
        <el-table-column property="page" label="校验页数" width="100" align="center"></el-table-column>
        <el-table-column property="money" label="金额（元）" width="100" align="center"
                         v-if="isShowMoney"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <div style="float: left;
    font-size: 14px;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    color: #333333;
width: 80%"
        >
          <div style="float: left">
            总计：<span>{{ pages }}</span>页
          </div>
          <div style="float: right" v-if="isShowMoney">
            <span style="padding-right: 15px;">总价：￥{{ NumFilter(orderMoney) }}</span>
            <span style="padding-right: 15px;">优惠：
              <span style="color:#e13f3f;">{{ NumberSub(orderMoney, moneys) }}</span>
            </span>
            <span style="padding-right: 15px;">实付：
              <span style="color:#e13f3f;font-size: 18px;">￥{{ NumFilter(moneys) }}</span>
            </span>
          </div>
        </div>
        <el-button v-if="!isShowFree" type="primary" data-track-text="确认提交订单" aria-label="确认提交订单" @click="submitPay" class="okTranslate">
          <span v-if="checkType==='first'">确认翻译</span>
          <span v-if="checkType!=='first'">确认转换</span>
        </el-button>
        <el-button v-if="isShowFree" type="primary" data-track-text="免费提交订单" aria-label="免费提交订单" @click="submitPay" class="okTranslate">
          <span v-if="checkType==='first'">免费翻译</span>
          <span v-if="checkType!=='first'">免费转换</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  payRequest,
  deleteFileRequest,
  fileListRequest,
  fileStatus,
  readingFileRequest,
  statusRequest,
  translateServiceClient,
  readDocumentRequest,
  queryDocumentRequest,
  submitRequest,
  parentPowerRequest,
  submitConvertRequest,
  FileListRequest
} from '../tools/api/translate-api'
import lanuages from '../../language.json'

export default {
  name: "FileList",
  data() {
    return {
      activeName: 'first',
      isShowMoney: false,
      isShowFree: false,
      from: '',
      to: '',
      moneys: 0,
      orderMoney: 0,
      pages: 0,
      gridData: [],
      dialogTableVisible: false,
      customColorDownload: '#1b5ea4 !important',
      downloadMessage: '下载大型文档或转换文档时，需等待时间较长请您耐心等待！',
      downloadClass: 'downloadClass',
      downloadStatus: '',
      downloadPercentage: 0,
      isDownload: true,
      downloadTitle: '确定下载该文件的译文版本吗？',
      excelDialogVisibleConvert: false,
      deletevisible: false,
      customColor: '#4aaaea !important',
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      count: 0,
      currentConvertPage: 1,
      pageConvertSize: 10,
      countConvert: 0,
      fileStatus: [
        {value: 0, label: "全部"},
        {value: 3, label: "已翻译"},
        {value: 4, label: "已下载"}
      ],
      multipleSelection: [],
      tableData: [],
      transloading: false,
      convertloading: false,
      convertTableData: [],
      statusList: '',
      fileName: "",
      content: "",
      title: "",
      radio: 'pdf',
      centerDialogVisible: false,
      excelDialogVisible: false,
      downloadDocLoad: false,
      timer: '',
      timerConvert: '',
      downloadTimer: '',
      downloadId: "",
      checkType: "first",
      fullscreenLoadings: undefined,
    }
  },
  created() {
    const req = this.getUrlParameter(this.$route.fullPath).response;
    if (req !== undefined && req !== null && req !== "") {
      this.checkPay(req);
    } else {
      if (this.$route.query.type !== undefined) {
        this.activeName = 'second'
        this.initConvertFileList();
      } else {
        this.activeName = 'first'
        this.initFileList();
      }
    }
  },
  mounted() {
    this.timer = setInterval(this.RandomNumBoth, 5000);
    this.timerConvert = setInterval(this.RandomNumBothConvert, 5000);
  },
  watch: {
    dialogTableVisible(val) {
      if (val) {
        let request = parentPowerRequest;
        request.setMoney(this.moneys)
        const TOKEN_KEY = "token";
        translateServiceClient.checkParentPower(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          this.isShowMoney = res.getShowmoney();
          if (this.isShowMoney && this.moneys === 0) {
            this.isShowFree = true;
          }
        }).catch(err => {
          this.isShowMoney = true;
        })
      }
    }
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name === "first") {
        this.activeName = 'first'
        this.checkType = tab.name
        this.fileStatus = [
          {value: 0, label: "全部"},
          {value: 3, label: "已翻译"},
          {value: 4, label: "已下载"}
        ];
        if (this.tableData.length === 0) {
          this.initFileList();
        }
      } else {
        this.activeName = 'second'
        this.checkType = tab.name
        this.fileStatus = [
          {value: 0, label: "全部"},
          {value: 3, label: "已转换"},
          {value: 4, label: "已下载"}
        ];
        if (this.convertTableData.length === 0) {
          this.initConvertFileList()
        }
      }

    },
    checkPay(req) {
      const request = payRequest;
      request.setResponse(req);
      const TOKEN_KEY = "token";
      translateServiceClient.checkPay(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (!res.getIspay()) {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: "支付失败！"
          });
        }
        if (res.getUploadType() === 0) {
          this.activeName = 'first'
          this.initFileList();
        } else {
          this.activeName = 'second'
          this.initConvertFileList();
        }
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "检查支付异常，请稍后！"
        });
      })
    },
    initConvertFileList() {
      const TOKEN_KEY = 'token';
      let request = new FileListRequest();
      request.setUploadtype(1)
      this.convertloading = true
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then((res) => {
        this.buildConvertDatalist(res)
        this.convertloading = false
      }).catch(err => {
        this.convertloading = false
        if (err && err.code === 5) {
          this.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
        }
      })
    },
    initFileList() {
      const TOKEN_KEY = 'token';
      let request = new FileListRequest();
      request.setUploadtype(0)
      this.transloading = true
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then((res) => {
        this.buildDatalist(res)
        this.transloading = false
      }).catch(err => {
        this.transloading = false
        if (err && err.code === 5) {
          this.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
        }
      })
    },
    getUrlParameter(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split('?');
      url = url[url.length - 1];
      let obj = {};
      url.split('&&').map((query) => {
        let temp = query.split('=');
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    pay(row) {
      this.gridData = [];
      this.to = row.language;
      const data = {};
      data.id = row.id;
      data.title = row.name;
      data.page = row.pageNum;
      let request = queryDocumentRequest;
      request.setId(row.id);
      const TOKEN_KEY = "token";
      translateServiceClient.queryDocument(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getMessage()) {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          return;
        }
        data.page = res.getPage()
        data.money = res.getOrderMoney()
        this.moneys = res.getMoney()
        this.orderMoney = res.getOrderMoney()
        this.pages = res.getPage()
        this.dialogTableVisible = true;
        this.gridData.push(data)
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "支付异常请稍后"
        });
      })
    },
    submitConvert() {
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id)
      })
      let request = submitConvertRequest;
      request.setIdsList(ids).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient.submitConvert(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          if (res.getMessage() !== undefined && res.getMessage() !== null && res.getMessage() !== "") {
            window.open(res.getMessage(), "_self");
            return;
          }
          let innerrequest = fileListRequest
          if (this.checkType === "first") {
            this.transloading = true
            innerrequest.setUploadtype(0)
          } else {
            this.convertloading = true
            innerrequest.setUploadtype(1)
          }
          translateServiceClient.fileList(innerrequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            if (this.checkType === "first") {
              this.transloading = false
              this.buildDatalist(res)
            } else {
              this.convertloading = false
              this.buildConvertDatalist(res)
            }
          }).catch(err => {
            this.transloading = false
            this.convertloading = false
            if (err && err.code === 5) {
              this.$router.push("/index")
              window.parent.postMessage({
                data: "params"
              }, '*');
            }
          })
          this.$message({
            center: true,
            type: 'success',
            showClose: true,
            duration: 3000,
            message: "支付成功"
          });
          this.dialogTableVisible = false;
          return
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "提交失败请稍后再试"
        });
      })
    },
    submitPay() {
      if (this.checkType !== "first") {
        this.submitConvert()
        return
      }
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id)
      })
      let request = submitRequest;
      request.setIdsList(ids);
      request.setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient.submit(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          if (res.getMessage() !== undefined && res.getMessage() !== null && res.getMessage() !== "") {
            window.open(res.getMessage(), "_self");
            return;
          }
          let innerrequest = new FileListRequest()
          if (this.checkType === "first") {
            this.transloading = true
            innerrequest.setUploadtype(0)
          } else {
            this.convertloading = true
            innerrequest.setUploadtype(1)
          }
          translateServiceClient.fileList(innerrequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            if (this.checkType === "first") {
              this.transloading = false
              this.buildDatalist(res)
            } else {
              this.convertloading = false
              this.buildConvertDatalist(res)
            }
          }).catch(err => {
            this.transloading = false
            this.convertloading = false
            if (err && err.code === 5) {
              this.$router.push("/index")
              window.parent.postMessage({
                data: "params"
              }, '*');
            }
          })
          this.$message({
            center: true,
            type: 'success',
            showClose: true,
            duration: 3000,
            message: "支付成功"
          });
          this.dialogTableVisible = false;
          return
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "提交失败请稍后再试"
        });
      })
    },
    indexConvertMethod(index) {
      return (this.currentConvertPage - 1) * this.pageConvertSize + index + 1;
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    RandomNumBoth() {
      this.tableData.forEach(item => {
        if (item.status === '排队中') {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = 'token';
          translateServiceClient.checkStatus(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            const status = res.getStatus();
            if (status === 'Pending' || status === 'Pended' || status === 'Translating' || status === 'Translated' || status === 'Completing') {
              item.status = '翻译中'
              localStorage.setItem(item.id, 0);
            }
          }).catch(err => {
          })
          return;
        }
        if (item.status === '翻译中' || item.status === '处理中') {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = 'token';
          translateServiceClient.checkStatus(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            let nums = localStorage.getItem(item.id);
            let Range = 5 - 1;
            let Rand = Math.random();
            //四舍五入
            let num = 1 + Math.round(Rand * Range) + parseInt(nums);
            if (num > 99) {
              item.numbers = 99;
              num = 99;
              item.status = '处理中';
            } else {
              item.numbers = num;
            }
            localStorage.setItem(item.id, num);
            if (res.getStatus() === 'Complete') {
              item.status = '已翻译';
              item.disables.disablesread = false;
              item.disables.disablesdown = false;
              item.disables.disablesdel = false;
            }
            if (res.getStatus() === 'TransError') {
              item.status = '翻译失败';
              item.disables.disablesread = true;
              item.disables.disablesdown = true;
              item.disables.disablesdel = false;
            }
            if (res.getStatus() === 'DocError') {
              item.status = '翻译失败';
              item.disables.disablesread = true;
              item.disables.disablesdown = true;
              item.disables.disablesdel = false;
            }
            if (item.name.endsWith("xls") || item.name.endsWith("xlsx")) {
              item.disables.disablesread = true;
            }
            if (item.name.endsWith("jpg")
                || item.name.endsWith("jpeg")
                || item.name.endsWith("png")
                || item.name.endsWith("tif")) {
              item.disables.disablesread = true;
            }
            if (document.getName().endsWith("ppt")
                || document.getName().endsWith("pptx")) {
              item.disables.disablesread = true;
            }
          }).catch(err => {
          })
        }
      })
    },
    RandomNumBothConvert() {
      this.convertTableData.forEach(item => {
        if (item.status === '排队中') {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = 'token';
          translateServiceClient.checkStatus(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            const status = res.getStatus();
            if (status === 'Pending' || status === 'Pended' || status === 'Translating' || status === 'Translated' || status === 'Completing') {
              item.status = '转换中'
              localStorage.setItem(item.id, 0);
            }
          }).catch(err => {
          })
          return;
        }
        if (item.status === '转换中' || item.status === '处理中') {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = 'token';
          translateServiceClient.checkStatus(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            let nums = localStorage.getItem(item.id);
            let Range = 5 - 1;
            let Rand = Math.random();
            //四舍五入
            let num = 1 + Math.round(Rand * Range) + parseInt(nums);
            if (num > 99) {
              item.numbers = 99;
              num = 99;
              item.status = '处理中';
            } else {
              item.numbers = num;
            }
            localStorage.setItem(item.id, num);
            if (res.getStatus() === 'Complete') {
              item.status = '已转换';
              item.disables.disablesread = false;
              item.disables.disablesdown = false;
              item.disables.disablesdel = false;
            }
            if (res.getStatus() === 'TransError' || res.getStatus() === '翻译失败') {
              item.status = '转换失败';
              item.disables.disablesread = true;
              item.disables.disablesdown = true;
              item.disables.disablesdel = false;
            }
            if (res.getStatus() === 'DocError' || res.getStatus() === '翻译失败') {
              item.status = '转换失败';
              item.disables.disablesread = true;
              item.disables.disablesdown = true;
              item.disables.disablesdel = false;
            }
          }).catch(err => {
          })
        }
      })
    },
    readingFile(row) {
      let request = readDocumentRequest;
      const TOKEN_KEY = 'token';
      request.setId(row.id);
      translateServiceClient.checkReadDocument(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          let routeData = this.$router.resolve({
            name: "DocView",
            params: {documentId: row.id}
          });
          window.open(routeData.href, '_blank')
          return;
        }
        this.$message({
          center: true,
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        if (err && err.code === 5) {
          this.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
          return;
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "请稍后再试！"
        });
      })
    },
    base64ToBlob(code, type) {
      let bstr = atob(code)
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type: type});
    },
    downloadConvertFile(row) {
      this.downloadTitle = '确定下载该文件的word版本吗？';
      this.downloadClass = 'downloadConvertClass';
      this.downloadStatus = '';
      this.downloadMessage = '下载大型文档或转换文档时，需等待时间较长请您耐心等待！';
      this.downloadPercentage = 0;
      this.isDownload = true;
      this.downloadDocLoad = false;
      this.downloadId = row.id;
      this.radio = "docx";
      this.excelDialogVisibleConvert = true;
    },
    downloadFile(row) {
      this.downloadTitle = '确定下载该文件的译文版本吗？';
      this.downloadClass = 'downloadClass';
      this.downloadStatus = '';
      this.downloadMessage = '下载大型文档或转换文档时，需等待时间较长请您耐心等待！';
      this.downloadPercentage = 0;
      this.isDownload = true;
      this.downloadDocLoad = false;
      this.downloadId = row.id;
      this.radio = row.name.substring(row.name.lastIndexOf(".") + 1);
      if (this.radio === "ppt" || this.radio === "pptx" || this.radio === "xls" || this.radio === "xlsx" || this.radio === "png" || this.radio === "jpg" || this.radio === "jpeg" || this.radio === "tif") {
        this.fullscreenLoadings = this.$loading({
          lock: true,
          text: '正在下载',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.downloadDoc();
      } else {
        this.centerDialogVisible = true;
      }
    },
    downloadConvertDoc() {
      let request = readingFileRequest;
      request.setId(this.downloadId);
      request.setType(this.radio)
      const that = this;
      const TOKEN_KEY = 'token';
      let stream = translateServiceClient.downLoadConvertFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      });
      this.isDownload = false;
      this.downloadDocLoad = true;
      this.downloadClass = 'downloadClass2';
      this.downloadTitle = '';
      let flag = 0;
      let content = "";
      let title = "";
      let type = "";
      let size = 0;
      let count = 0;
      this.downloadTimer = setInterval(() => {
        if (this.downloadPercentage < 98) {
          this.downloadPercentage += 1;
        }
        if (this.downloadPercentage === 100) {
          count += 1;
          if (count === 3) {
            clearInterval(this.downloadTimer);
            this.isDownload = true;
            this.downloadDocLoad = false;
            this.centerDialogVisible = false;
            this.excelDialogVisibleConvert = false;
            this.excelDialogVisible = false;
            this.customColorDownload = '#1b5ea4';
          }
        }
        if (this.downloadPercentage === 99) {
          this.customColorDownload = '#38cb1c';
          this.downloadMessage = '下载完成'
          this.downloadPercentage = 100;
        }
      }, 1000);
      stream.on('data', (res) => {
        if (res.getStatus() && flag === 0) {
          title = res.getTitle();
          type = res.getType();
          size = res.getSize();
        }
        if (!res.getStatus() && flag === 0) {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          clearInterval(this.downloadTimer);
          this.isDownload = true;
          this.downloadDocLoad = false;
          this.centerDialogVisible = false;
          this.excelDialogVisibleConvert = false;
          this.excelDialogVisible = false;
          return;
        }
        flag++;
        content += res.getContent_asB64();
      });
      stream.on('end', (end) => {
        let aLink = document.createElement('a');
        let blob = that.base64ToBlob(content, type);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);
        aLink.download = title;
        aLink.href = window.URL.createObjectURL(blob)
        aLink.click();
        that.downloadPercentage = 99;
      });
      stream.on('error', (err) => {
        clearInterval(this.downloadTimer);
        that.isDownload = true;
        that.downloadDocLoad = false;
        that.centerDialogVisible = false;
        that.excelDialogVisibleConvert = false;
        that.excelDialogVisible = false;
        if (err && err.code === 5) {
          that.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
          return;
        }
        if (err && err.code !== 0) {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: '下载文档失败，请稍后再试！'
          })
        }
      });
    },
    downloadDoc() {
      let request = readingFileRequest;
      request.setId(this.downloadId);
      request.setType(this.radio)
      const that = this;
      const TOKEN_KEY = 'token';
      let stream = translateServiceClient.downLoadFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      });
      this.isDownload = false;
      this.downloadDocLoad = true;
      this.downloadClass = 'downloadClass2';
      this.downloadTitle = '';
      let flag = 0;
      let content = "";
      let title = "";
      let type = "";
      let size = 0;
      let count = 0;
      this.downloadTimer = setInterval(() => {
        if (this.downloadPercentage < 98) {
          this.downloadPercentage += 1;
        }
        if (this.downloadPercentage === 100) {
          count += 1;
          if (count === 3) {
            clearInterval(this.downloadTimer);
            this.isDownload = true;
            this.downloadDocLoad = false;
            this.centerDialogVisible = false;
            this.excelDialogVisible = false;
            this.excelDialogVisibleConvert = false;
            this.customColorDownload = '#1b5ea4';
          }
        }
        if (this.downloadPercentage === 99) {
          this.customColorDownload = '#38cb1c';
          this.downloadMessage = '下载完成'
          this.downloadPercentage = 100;
        }
      }, 1000);
      stream.on('data', (res) => {
        if (res.getStatus() && flag === 0) {
          title = res.getTitle();
          type = res.getType();
          size = res.getSize();
        }
        if (!res.getStatus() && flag === 0) {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          clearInterval(this.downloadTimer);
          this.isDownload = true;
          this.downloadDocLoad = false;
          this.centerDialogVisible = false;
          this.excelDialogVisible = false;
          this.excelDialogVisibleConvert = false;
          return;
        }
        flag++;
        content += res.getContent_asB64();
      });
      stream.on('end', (end) => {
        let aLink = document.createElement('a');
        let blob = that.base64ToBlob(content, type);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);
        aLink.download = title;
        aLink.href = window.URL.createObjectURL(blob)
        aLink.click();
        that.downloadPercentage = 99;
        if (that.fullscreenLoadings !== undefined) {
          that.fullscreenLoadings.close();
        }
      });
      stream.on('error', (err) => {
        clearInterval(this.downloadTimer);
        if (that.fullscreenLoadings !== undefined) {
          that.fullscreenLoadings.close();
        }
        that.isDownload = true;
        that.downloadDocLoad = false;
        that.centerDialogVisible = false;
        that.excelDialogVisibleConvert = false;
        that.excelDialogVisible = false;
        if (err && err.code === 5) {
          that.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
          return;
        }
        if (err && err.code !== 0) {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: '下载文档失败，请稍后再试！'
          })
        }
      });
    },
    deleteFile(scope) {
      const id = scope.row.id;
      let request = deleteFileRequest;
      request.setId(id);
      const TOKEN_KEY = 'token';
      translateServiceClient.deleteFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          this.$message({
            center: true,
            type: 'success',
            showClose: true,
            duration: 3000,
            message: '删除成功'
          })
          let innerrequest = new FileListRequest()
          if (this.checkType === "first") {
            this.transloading = true
            innerrequest.setUploadtype(0)
          } else {
            this.convertloading = true
            innerrequest.setUploadtype(1)
          }
          translateServiceClient.fileList(innerrequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            if (this.checkType === "first") {
              this.buildDatalist(res)
              this.transloading = false
            } else {
              this.convertloading = false
              this.buildConvertDatalist(res)
            }
          }).catch(err => {
            this.transloading = false
            this.convertloading = false
            if (err && err.code === 5) {
              this.$router.push("/index")
              window.parent.postMessage({
                data: "params"
              }, '*');
            }
          })
          return;
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: '删除失败'
        })
      }).catch(err => {
        if (err && err.code === 5) {
          this.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
        }
      });
      scope._self.$refs[`popover-${scope.$index}`].doClose();
    },
    buildConvertDatalist(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList()
      this.countConvert = count;
      this.convertTableData = [];
      const that = this;
      documentsList.forEach((document, index) => {
        const language = 'pdf-word';
        const pageNum = document.getPageNum() === '' ? '-' : document.getPageNum();
        let status = document.getStatus();
        if (status === "已翻译") {
          status = '已转换'
        }
        let number = 0;
        if (index === 0) {
          if (status === '排队中' && that.statusList !== 1) {
            status = '转换中'
          }
        }
        if (localStorage.getItem(document.getId()) && status !== '已转换' && status !== '已下载' && status !== '翻译失败' && status !== '已过期' && status !== '已删除') {
          status = '转换中'
        }
        if (status === '转换中') {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "已转换" || status === "已下载") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (document.getName().endsWith("xls") || document.getName().endsWith("xlsx")) {
          disablesread = true;
        }
        if (document.getName().endsWith("jpg")
            || document.getName().endsWith("jpeg")
            || document.getName().endsWith("png")
            || document.getName().endsWith("tif")) {
          disablesread = true;
        }
        if (document.getName().endsWith("ppt")
            || document.getName().endsWith("pptx")) {
          disablesread = true;
        }
        if (status === "翻译失败") {
          status = '转换失败'
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode()
        };
        this.convertTableData.push(data);
      })
    },
    buildDatalist(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList()
      this.count = count;
      this.tableData = [];
      const that = this;
      documentsList.forEach((document, index) => {
        const to = that.getChineseName(document.getTo());
        const from = that.getChineseName(document.getFrom());
        const language = from + '-' + to;
        const pageNum = document.getPageNum() === '' ? '-' : document.getPageNum();
        let status = document.getStatus();
        let number = 0;
        if (index === 0) {
          if (status === '排队中' && that.statusList !== 1) {
            status = '翻译中'
          }
        }
        if (localStorage.getItem(document.getId()) && status !== '已翻译' && status !== '已下载' && status !== '翻译失败' && status !== '已过期' && status !== '已删除') {
          status = '翻译中'
        }
        if (status === '翻译中') {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "已翻译" || status === "已下载") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (document.getName().endsWith("xls") || document.getName().endsWith("xlsx")) {
          disablesread = true;
        }
        if (document.getName().endsWith("jpg")
            || document.getName().endsWith("jpeg")
            || document.getName().endsWith("png")
            || document.getName().endsWith("tif")) {
          disablesread = true;
        }
        if (document.getName().endsWith("ppt")
            || document.getName().endsWith("pptx")) {
          disablesread = true;
        }
        if (status === "翻译失败") {
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode()
        };
        this.tableData.push(data);
      })
    },
    getChineseName(lanuage) {
      let label = lanuage;
      lanuages.forEach((item) => {
        if (item.value === lanuage) {
          label = item.label;
        }
      })
      return label;
    },
    handleNameChange() {
      let that = this
      let request = new FileListRequest();
      if (this.checkType === "first") {
        this.transloading = true
        request.setUploadtype(0)
      } else {
        this.convertloading = true
        request.setUploadtype(1)
      }
      request.setFileName(this.fileName)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (that.checkType === "first") {
          that.buildDatalist(res)
          this.transloading = false
        } else {
          that.buildConvertDatalist(res)
          this.convertloading = false
        }
      }).catch(err => {
        this.transloading = false
        this.convertloading = false
        if (err && err.code === 5) {
          this.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
        }
      })
    },
    handleStatusChange() {
      let that = this
      let request = new FileListRequest()
      if (this.checkType === "first") {
        request.setUploadtype(0)
        this.transloading = true
      } else {
        request.setUploadtype(1)
        this.convertloading = true
      }
      if (this.statusList === 0) {
        request.setFileStatusList([])
        const TOKEN_KEY = 'token';
        translateServiceClient.fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
        }).then(res => {
          if (that.checkType === "first") {
            that.buildDatalist(res)
            this.transloading = false
          } else {
            that.buildConvertDatalist(res)
            this.convertloading = false
          }
        }).catch(err => {
          this.transloading = false
          this.convertloading = false
          if (err && err.code === 5) {
            this.$router.push("/index")
            window.parent.postMessage({
              data: "params"
            }, '*');
          }
        })
        return;
      }
      request.setFileName(this.fileName)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (that.checkType === "first") {
          that.buildDatalist(res)
          this.transloading = false
        } else {
          that.buildConvertDatalist(res)
          this.convertloading = false
        }
      }).catch(err => {
        this.transloading = false
        this.convertloading = false
        if (err && err.code === 5) {
          this.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
        }
      })
    },
    handleConvertSizeChange(val) {
      this.pageConvertSize = val;
      let request = new FileListRequest();
      this.convertloading = true
      request.setPagesize(this.pageSize)
      request.setFileName(this.fileName)
      request.setUploadtype(1)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildConvertDatalist(res)
        this.convertloading = false
      }).catch(err => {
        this.convertloading = false
        if (err && err.code === 5) {
          this.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      let request = new FileListRequest();
      this.transloading = true
      request.setPagesize(this.pageSize)
      request.setFileName(this.fileName)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildDatalist(res)
        this.transloading = false
      }).catch(err => {
        this.transloading = false
        if (err && err.code === 5) {
          this.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
        }
      })
    },
    handleConvertCurrentChange(val) {
      this.currentConvertPage = val
      let request = new FileListRequest();
      request.setPagesize(this.pageConvertSize)
      request.setCurrentpage(this.currentConvertPage)
      request.setFileName(this.fileName)
      this.convertloading = true
      request.setUploadtype(1)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildConvertDatalist(res)
        this.convertloading = false
      }).catch(err => {
        this.convertloading = false
        if (err && err.code === 5) {
          this.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
        }
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      let request = new FileListRequest();
      this.transloading = true
      request.setPagesize(this.pageSize)
      request.setCurrentpage(this.currentPage)
      request.setFileName(this.fileName)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildDatalist(res)
        this.transloading = false
      }).catch(err => {
        this.transloading = false
        if (err && err.code === 5) {
          this.$router.push("/index")
          window.parent.postMessage({
            data: "params"
          }, '*');
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 !== 0) {
        return 'warning-row';
      }
      return 'rows';
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.downloadTimer);
    clearInterval(this.timerConvert);
  }
}
</script>

<style lang="less" scoped>
/deep/ .demo-form-inline .el-input__suffix-inner {
  padding-right: 10px !important;
}

/deep/ .demo-form-inline .el-input__icon {
  padding-right: 10px !important;
}

/deep/ .demo-form-inline .el-icon-arrow-up:before {
  content: "\e6e1";
  font-size: 25px;
  line-height: 42px;
  color: #999999;
  font-weight: 400;
}

/deep/ .demo-form-inline .el-icon-search:before {
  content: "\e778";
  font-size: 25px;
  line-height: 42px;
  color: #999999;
  font-weight: 400;
}

/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__nav-wrap::after {
  display: none;
}

/deep/ .el-tabs__item {
  border: 1px solid #DDDDDD;
  padding: 0px 0px;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #194687;
  width: 96px;
  height: 40px;
  margin-right: 10px;
}

/deep/ .el-tabs__item.is-active {
  border: 1px solid #DDDDDD;
  padding: 0px 0px;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  background-color: #194687;
  width: 96px;
  height: 40px;
  margin-right: 10px;
}

/deep/ .payClass {
  .el-dialog {
    min-width: 800px;
  }

  .shanchu {
    text-decoration: line-through;
  }

  .el-dialog__footer {
    padding: 10px 30px 20px !important;
  }

  .el-dialog__body {
    padding: 30px 30px !important;
  }

  .el-dialog__header {
    padding: 20px 30px 10px !important;
  }

  .okTranslate {
    border-color: #184482;
    width: 142px;
    height: 40px;
    background: #184482;
    border-radius: 2px;
    font-size: 14px;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
  }

  .noTranslate {
    border-color: #184482;
    color: #184482;
    width: 142px;
    height: 40px;
    border-radius: 2px;
    font-size: 14px;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
  }

  .fanyiyuyan {
    font-size: 18px;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    color: #333333;
    float: left;
    line-height: 48px;
  }

  .dialog-title {
    text-align: left;
    width: 100%;
    margin-bottom: 30px;

    .el-form--inline .el-form-item, .el-form--inline .el-form-item__content {
      display: inline-block;
      vertical-align: baseline;
      margin: 0;
      padding: 0;
    }
  }
}

/deep/ .listprogress {
  .el-progress__text {
    font-size: 12px !important;
  }
}

/deep/ .el-alert.is-center {
  background: #fffff1 !important;
  height: 37px;

  .el-alert__title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9a9a9a;
  }
}

.hr {
  width: 100%;
  height: 20px;
  background-color: #f5f5f5;
  border: 0;
  z-index: 1;
  margin-top: 0;
  padding: 0;
  margin-bottom: 0;
}

/deep/ .el-input--suffix .el-input__inner {
  background-color: #F5F5F5;
  width: 252px;
  height: 40px;
  border-radius: 4px;
  border: 0px;
  color: #5f5f5f;
  font-size: 14px;
  font-weight: 400;
  font-family: MicrosoftYaHei;
}

/deep/ .el-input--small .el-input__inner {
  background-color: #F5F5F5;
  width: 252px;
  height: 40px;
  border-radius: 4px;
  border: 0px;
  color: #5f5f5f;
  font-size: 14px;
  font-weight: 400;
  font-family: MicrosoftYaHei;
}

/deep/ .el-radio {
  .el-radio__input {
  }

  &.is-checked {
    position: relative;

    &:after {
      content: "";
      display: block;
      height: 16px;
      width: 16px;
      background-image: url(../assets/duigou.png);
      background-size: 100%;
      position: absolute;
      top: 0px !important;
    }
  }
}

/deep/ .downloadConvertClass {
  height: 200px;
  border-radius: 6px;
}

/deep/ .downloadClass {
  height: 430px;
  border-radius: 6px;
}

/deep/ .downloadClass2 {
  width: 550px;
  height: 317px;
  border-radius: 6px;
}

/deep/ .down-type {
  float: left;
  margin: 0 25px;
}

/deep/ .down-type2 {
  float: left;
  margin: 0 75px;
}

/deep/ .el-radio__label {
  display: none !important;
}

/deep/ .el-button--primarys {
  width: 103px !important;
  height: 40px !important;
  background: #184482 !important;
  border-radius: 3px !important;
  color: #ffffff !important;
  border-color: #184482 !important;
  font-size: 16px !important;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  line-height: 0 !important;
}

/deep/ .el-button--defaults {
  width: 103px !important;
  height: 38px !important;
  background: #ffffff !important;
  color: #1c50a8 !important;
  border: 1px solid #1c50a8 !important;
  border-radius: 3px !important;
  font-size: 16px !important;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  line-height: 0 !important;
}

/deep/ .el-radio {
  margin: 0 !important;
  position: absolute !important;
}

/deep/ .el-dialog__title {
  width: 278px;
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;

}

/deep/ .fanyi {
  font-size: 14px;
  color: rgb(51, 51, 51);
}

/deep/ .zhuangtai {
  font-size: 14px;
  color: rgb(51, 51, 51);
}

/deep/ .yeshu {
  font-size: 14px;
  color: rgb(51, 51, 51);
}

/deep/ .wendang {
  font-size: 14px;
  color: rgb(51, 51, 51);
}

/deep/ .caozuo {
  font-size: 14px;
  color: rgb(51, 51, 51);
}

/deep/ .xuhao {
  font-size: 14px;
  color: rgb(51, 51, 51);
}

/deep/ .rows {
  font-size: 14px;
}

/deep/ .el-table_1_column_5 {
  //display: none;
}

/deep/ .el-progress {
  .el-progress el-progress--line {
    .el-progress__text {
      font-size: 1px !important
    }
  }
}

/deep/ .el-dialog__body {
  padding: 0 !important;
}

/deep/ .el-dialog--center .el-dialog__body {
  text-align: inherit !important;
}

/deep/ .el-row a {
  margin: 20px;
}

/deep/ .filelist-domain {
  height: 894px;
  width: 1200px;
}

/deep/ .el-table .warning-row {
  background: #f2f5f8;
  font-size: 14px;
}

/deep/ .el-table .header-row {
  background: #ececec !important;
}
</style>
